import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import AppBar from "@material-ui/core/AppBar"
import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import { Cookies } from "react-cookie"
import ChangeReportFinansialSumWallet from "./ChangeReportFinansialSumWallet"
import ChangeReportFinansialWallet from "./ChangeReportFinansialWallet"
import ChangeReportFinancialRequest from "./ChangeReportFinancialRequest"

import * as constants from "../constants"
import ChangeWalletBalance from "./ChangeWalletBalance";

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
})

class ChangeReportFinancial extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)
            this.state = {
                  value: 0,
            }
      }

      componentDidMount() {}
      handleChange = (event, newValue) => {
            this.setState({ value: newValue })
      }
      render() {
            const { classes } = this.props
            const { value } = this.state

            return (
                  <div style={{ dir: "rtl", direction: "rtl" }}>
                        <AppBar style={{ dir: "rtl" }} position="sticky" color="primary">
                              <Tabs
                                    style={{ height: "60px", textAlign: "center", dir: "rtl" }}
                                    value={value}
                                    onChange={this.handleChange}
                                    indicatorColor="secondary"
                                    textColor={"#000000"}
                                    variant="scrollable"
                                    scrollButtons="on"
                                    aria-label="scrollable force tabs example"
                              >
                                    <Tab label="تغییر موجودی کیف پول" />
                                    <Tab label="گزارشات کیف پول کاربر" />
                                    <Tab label="گزارشات جمع کیف پول کاربران" />
                                    <Tab label="گزارشات مالی درخواست ها" />
                              </Tabs>
                        </AppBar>
                        {value === 0 ? <ChangeWalletBalance props={this.props} /> : null}
                        {value === 1 ? <ChangeReportFinansialWallet props={this.props} /> : null}
                        {value === 2 ? <ChangeReportFinansialSumWallet props={this.props} /> : null}
                        {value === 3 ? <ChangeReportFinancialRequest props={this.props} /> : null}
                  </div>
            )
      }
}

export default withStyles(styles)(ChangeReportFinancial)
